// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Reunion from '../_raw/flag/icon_flag_reunion.png';

export default () => <img src={Reunion} alt="Reunion" />;
